import React, {useState, useEffect} from 'react';

const url = process.env.REACT_APP_MAILCHIMP_SERVER_URL

export const Contact  = () => {
      const [email, setEmail] = useState(''); 
      const [fname, setFname] = useState('');
      const [lname, setLname] = useState('');
      const [response, setResponse] = useState('')

      const handleFormSubmit = async (e) => {
         e.preventDefault()
         setResponse('joining...')
         const headers ={
            'Content-type': 'application/json'
          }
          const body = {
            email,
            fname,
            lname
          }

          fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
          })
            .then((res) => {
              if (res.ok) {
                console.log(res);
                setResponse('Successfully joined.');
              } else {
               setResponse('Server Error.');
              }
            })
            .catch((e) => {
              console.log(e);
              setResponse('Server Error.');
            });
      }

      return (
         <section id="contact" className="contact">
            <div className="contact-decor">
               <div className="contact-circle1"><img src="assets/images/main-banner12.png" alt="" /></div>
               <div className="contact-circle2"><img src="assets/images/main-banner1.png" alt="" /></div>
            </div>
            <div className="container">
               <div className="row">
                  <div className="col-md-12 col-lg-8 col-sm-12">
                     <div className="contact-us">
                        <div className="w-100">
                           <h2 className="title"><span>Join </span>Our Community</h2>
                           <form className="theme-form">
                              <div className="form-group">
                                 <div className="row">
                                    <div className="col-sm-12 col-md-6 md-fgrup-margin">
                                       <input type="text" className="form-control" placeholder="first name" value={fname} onChange={(e)=> setFname(e.target.value)} required="required" />
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                       <input type="text" className="form-control" placeholder="last name" value={lname} onChange={(e)=> setLname(e.target.value)}/>
                                    </div>
                                 </div>
                              </div>
                              <div className="form-group">
                                 <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="email address" required="required"  value={email} onChange={(e)=> setEmail(e.target.value)}/>
                              </div>
                              <div style={{marginTop:'20px',marginBottom:'20px', padding:'10px', backgroundColor: 'rgba(255,255,255,0.8)', borderRadius:'5px', color:'#333'}}>Stay up to date with the latest news from DropSpin, be first to know about new features, and learn how the most effective groups in the world utilize DropSpin to optimize their rehearsal process.</div>
                              <div className="form-button" onClick={handleFormSubmit}>
                                 <button type="submit" className="btn btn-custom theme-color">send</button>
                              </div>
                              <div>{response}</div>
                           </form>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 d-medium-none-lg">
                     <div className="contact-right">
                        <img src="assets/images/Contact-info.png" className="img-fluid" alt="" />
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }



export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact.js